import { loadModules } from 'esri-loader';
import appConfig from '../config/appConfig';

export default class FeatureLayerHelper {
  static async createClientsideFeatureLayer(featureLayerDef) {
    const [FeatureLayer] = await loadModules(['esri/layers/FeatureLayer']);

    const featureLayer = new FeatureLayer(featureLayerDef);

    const response = await featureLayer.queryFeatures();

    if (featureLayer.id === 'NextEraFacilities' && featureLayer.renderer) {
      featureLayer.renderer.uniqueValueInfos.map((i) => {
        if (appConfig.excludeLegendItems.includes(i.label)) {
          if (i.symbol.outline) {
            i.symbol.outline.color.a = 0;
            i.symbol.outline.width = 0;
          }
        }
      })
    }

    const clientsideFeatureLayer = new FeatureLayer({
      source: response.features,
      objectIdField: featureLayer.objectIdField,
      geometryType: featureLayer.geometryType,
      spatialReference: featureLayer.spatialReference,
      displayField: featureLayer.displayField,
      visible: featureLayer.visible,
      renderer: featureLayer.renderer,
      fields: featureLayer.fields,
      popupTemplate: featureLayer.popupTemplate,
      minScale: featureLayer.minScale,
      maxScale: featureLayer.maxScale,
      title: featureLayer.title
    });
    return clientsideFeatureLayer;
  }
}
